import React, {useState} from 'react';
import '../App.css';
import { baseUrl } from '../components/BaseUrl';
import { Link, useParams } from 'react-router-dom';
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from 'axios';
import logo from '../assets/img/logo.png';
const date = new Date();


const ChangePassword = () => {
const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [loading, setLoading] = useState(false);
const [disabled, setDisabled] = useState(false);
const [passwordVisibile, setPasswordVisible] = useState(false);
const { id } = useParams();

 const showPassword = () => {
   if(passwordVisibile === false){
     setPasswordVisible(true);
   }else{
     setPasswordVisible(false)
   }
 }

const validate = () => {
  if(password === ""){
    Swal.fire({
      title: "Empty Submission",
      text: "Please enter your password",
      icon: "error",
      confirmButtonText: "OK",
      backdrop: `
      rgba(143, 70, 0, 0.3)
      url("")
      left top
      no-repeat
    `
    });
  }else{
    changePassword()
  }
}

const changePassword = () => {
    setLoading(true);
    setDisabled(true);
    const userData = {
      email: id,
      password: password
    };
    axios.post(`${baseUrl}change-password.php`, userData).then((response) => {
      console.log(response.data)
      if(response.data.status === 0){
        setLoading(false);
        setDisabled(false);
        Swal.fire({
          title: "Error!",
          text: "An error occurred",
          icon: "error",
          confirmButtonText: "OK",
          backdrop: `
          rgba(143, 70, 0, 0.3)
          url("")
          left top
          no-repeat
        `
        });
      }else if(response.data.status === 1){
      setLoading(false);
      setDisabled(false);
      let timerInterval
      Swal.fire({
      title: 'Password updated successfully',
      icon: "success",
      html: 'Redirecting in <b></b> milliseconds.',
      timer: 1000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
        const b = Swal.getHtmlContainer().querySelector('b')
        timerInterval = setInterval(() => {
          b.textContent = Swal.getTimerLeft()
        }, 100)
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        window.location.replace("/login")
      }
    })
      }
    });
  };

return(
  <div>
    <section className="login-section">
      <img src={logo} className="logo" />
    {/*  <p className="text-light">Because learning shouldn't have any boundaries ...</p> */}
       <div className="email-box">
           <div className="form-value">
               <form>
                   <h3 className="text-light text-center">Enter New Password</h3>
                   <div className="inputbox">
                       <ion-icon name="lock-closed- le"></ion-icon>
                       <input type={passwordVisibile ? "text" : "password"} required onChange={(e) =>
                         setPassword(e.target.value)}
                        />
                       <label htmlFor="">Password</label>
                       <i onClick={showPassword} className={passwordVisibile ? "fa fa-eye-slash text-light visibility-icon" : "fa fa-eye text-light visibility-icon"}></i>
                   </div>

                   <button disabled={disabled} type="button" onClick={validate}>
                   {loading ? (
                     <Spinner animation="border" variant="light" size="sm" />
                   ) : (
                     "Next"
                   )}
                   </button>

                   <div className="register">
                       <p>Already have an account? <Link to="/login">Login</Link></p>
                   </div>

               </form>
           </div>
       </div>
       <p className="mt-4 text-light font-weight-bold"><a  className="text-light text-decoration-none font-weight-bold" href="https://codeflarelimited.com" target="_blank">Codeflare</a> | &copy; {date.getFullYear()}</p>
   </section>
   </div>
  )
}

export default ChangePassword
